<template>
    <div class="home-slider-wrapper">
        <swiper ref="swiper" class="home-slider" :options="sliderSettings">
            <swiper-slide v-for="(item, index) in slides" :key="index">
                <div class="item" :class="{load: item.iframeSrc, 'empty-link': !item.buttonText}">
                    <div class="item__box">
                        <div class="item__content">
                            <h2 v-text="item.title"/>
                            <p v-html="item.description"/>
                            <router-link class="link" :to="item.buttonLink" v-if="item.buttonText"
                                         v-text="item.buttonText" @click.native.prevent.stop="trackButtonClick(item.buttonLink)"/>
                        </div>
                        <div class="item__iframe" v-if="item.iframeSrc">
                            <iframe :data-src="item.iframeSrc" :title="item.title" frameborder="0" height="100%"
                                    scrolling="no" width="100%"/>
                        </div>
                        <div class="item__image" v-else>
                            <picture>
                                <source :data-srcset="(isDeviceMobile ? item.mobileImage : item.desktopImage)[sourceType]" :type="`image/${sourceType}`"
                                        v-for="(sourceType, index) in (isDeviceMobile ? item.mobileImage : item.desktopImage).sourcesTypes" :key="index">
                                <img :data-src="(isDeviceMobile ? item.mobileImage : item.desktopImage).jpg" :alt="item.title"/>
                            </picture>
                        </div>
                        <router-link class="linkMobal" :to="item.buttonLink" v-if="item.buttonText"
                                     v-text="item.buttonText"/>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div id="button-next-relacionados" class="swiper-button-next swiper-button-white" @click="swiperNext()"></div>
        <div id="button-prev-relacionados" class="swiper-button-prev swiper-button-white" @click="swiperPrev()"></div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import {sliderMainAutoplayDelay, mainSliderChangeSlideDuration} from "../../../../../config/slider";
import apiData from "../../../../mixins/apiData";
import eventsInterface from "../../../../interfaces/eventsInterface";

export default {
    name: "MultiSlideSlider",

    components: {
        Swiper,
        SwiperSlide,
    },

    mixins: [apiData],

    props: ['items'],

    data: function () {
        return {
            sliderInterval: undefined,
        };
    },

    serverPrefetch() {
        return this.slider && this.fetchData();
    },

    mounted() {
        this.slider && this.fetchData().then(() => this.swiper && setTimeout(() => {
            if (sliderMainAutoplayDelay) {
                this.sliderInterval = setInterval(() => this.swiper.slideNext(mainSliderChangeSlideDuration), sliderMainAutoplayDelay);
            }

            this.loadCurrentImages();

            this.swiper.on('beforeTransitionStart', this.loadCurrentImages);
        }, 300));
    },

    beforeDestroy() {
        clearInterval(this.sliderInterval);
        this.sliderInterval = null;
    },

    watch: {
        user(user, oldUser) {
            if (user && !oldUser || !user && oldUser) {
                this.slider && this.fetchData(true).then(() => this.swiper && setTimeout(() => this.loadCurrentImages(true), 100));
            }
        },
    },

    computed: {
        slider() {
            return this.items && this.items[0];
        },

        sliderSettings() {
            return {
                init: true,
                loop: true,
                centeredSlides: true,
                slidesPerView: 1,
                initialSlide: 0,
                watchSlidesVisibility: false,
                direction: 'horizontal',
                spaceBetween: 0,
                speed: mainSliderChangeSlideDuration,
                navigation: {
                    nextEl: '#button-next-relacionados',
                    prevEl: '#button-prev-relacionados',
                },
            }
        },

        isDeviceMobile(){
            return this.$store.state.isDeviceMobile;
        },

        swiper() {
            return this.$refs && this.$refs.swiper && this.$refs.swiper.$swiper;
        },

        locale() {
            return this.$store.state.locale;
        },

        user() {
            return this.$store.state.user;
        },

        currency() {
            return (this.user && this.user.currency) || this.$store.state.guestCurrency;
        },

        slides() {
            return this.slider && this.$store.state.sliderSlides[this.slider.id];
        },
    },

    methods: {
        fetchData(mustReload) {
            return this.$store.dispatch('FETCH_SLIDER_SLIDES', this.createApiData({
                sliderId: this.slider.id,
                currency: this.currency,
                mustReload: mustReload,
            }));
        },

        loadCurrentImages(refresh = false) {
            let activeSlideIndex = this.swiper.activeIndex;

            for (let i = -1; i <= 1; i++) {
                let slide = this.swiper.slides[activeSlideIndex + i];

                slide && (!slide.imageLoaded || refresh) &&  this.loadImage(slide);
            }
        },

        loadImage(slide) {
            let activeSlideMedia, activeSlideSources = null;

            let activeSlideImages = slide.getElementsByTagName('img');

            if (activeSlideImages.length) {
                activeSlideMedia = activeSlideImages[0];
                activeSlideSources = slide.getElementsByTagName('source');
            } else {
                let activeSlideIframes = slide.getElementsByTagName('iframe');

                if (activeSlideIframes.length) {
                    activeSlideMedia = activeSlideIframes[0];
                }
            }

            if (activeSlideMedia) {
                activeSlideMedia.addEventListener('load', function () {
                    this.parentElement.parentElement.parentElement.parentElement.classList.add('load');
                });

                activeSlideSources && Array.prototype.forEach.call(activeSlideSources, activeSlideSource => activeSlideSource.setAttribute('srcset', activeSlideSource.dataset.srcset));

                activeSlideMedia.setAttribute('src', activeSlideMedia.dataset.src);
            }

            slide.imageLoaded = true;
        },

        swiperNext() {
            this.swiper && this.swiper.slideNext(mainSliderChangeSlideDuration);
        },

        swiperPrev() {
            this.swiper && this.swiper.slidePrev(mainSliderChangeSlideDuration);
        },

        trackButtonClick(url) {
            void require('../../../../util/analytics/index').trackEvent(eventsInterface.clickSlideButton, this, {url});
        },
    }
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/sliders/MultiSlideSlider"
</style>
